export default __webpack_public_path__ + "static/media/grabbing.c1e71226.cur";